import { _ } from "../../../../helpers/dom-selectors.js";
import makeForm from "../../../global-components/form.js";
import APP_EVENTS from "../init/events.js";
const InviteForm = makeForm({
    form: _('inviteForm'),
    submitBtn: _('inviteBtn'),
    preventDefault: true,
    events: APP_EVENTS,
    action: 'invite-form-submitted',
});
export default InviteForm;
